export enum CostType {
  fixed = 0,
  unfixed = 1
}